// convert number in bytes into string like '1 MB'
export function bytesToSize (bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  if (bytes === 0) return '0 Bytes'
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  let dec = (bytes / Math.pow(1024, i)).toFixed(2).slice(0, -1)
  if (dec.split('.')[1] === '0') dec = dec.split('.')[0]
  return `${dec} ${sizes[i]}`
}